import { ConsultationPaymentErrorCard } from "~/features/appointments/components/consultation-payment-card";
// import { AppointmentBookingError } from "~/features/appointments/pages/error";

export function AppointmentErrorPage() {
  return (
    <ConsultationPaymentErrorCard />
  );
}
